"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerInpInteractionListener = registerInpInteractionListener;
exports.startTrackingINP = startTrackingINP;

var _core = require("@sentry/core");

var _instrument = require("./instrument.js");

var _utils = require("./utils.js");

const LAST_INTERACTIONS = [];
const INTERACTIONS_SPAN_MAP = new Map();
/**
 * Start tracking INP webvital events.
 */

function startTrackingINP() {
  const performance = (0, _utils.getBrowserPerformanceAPI)();

  if (performance && _core.browserPerformanceTimeOrigin) {
    const inpCallback = _trackINP();

    return () => {
      inpCallback();
    };
  }

  return () => undefined;
}

const INP_ENTRY_MAP = {
  click: 'click',
  pointerdown: 'click',
  pointerup: 'click',
  mousedown: 'click',
  mouseup: 'click',
  touchstart: 'click',
  touchend: 'click',
  mouseover: 'hover',
  mouseout: 'hover',
  mouseenter: 'hover',
  mouseleave: 'hover',
  pointerover: 'hover',
  pointerout: 'hover',
  pointerenter: 'hover',
  pointerleave: 'hover',
  dragstart: 'drag',
  dragend: 'drag',
  drag: 'drag',
  dragenter: 'drag',
  dragleave: 'drag',
  dragover: 'drag',
  drop: 'drag',
  keydown: 'press',
  keyup: 'press',
  keypress: 'press',
  input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */

function _trackINP() {
  return (0, _instrument.addInpInstrumentationHandler)(({
    metric
  }) => {
    if (metric.value == undefined) {
      return;
    }

    const entry = metric.entries.find(entry => entry.duration === metric.value && INP_ENTRY_MAP[entry.name]);

    if (!entry) {
      return;
    }

    const interactionId = entry.interactionId;
    const interactionType = INP_ENTRY_MAP[entry.name];
    /** Build the INP span, create an envelope from the span, and then send the envelope */

    const startTime = (0, _utils.msToSec)(_core.browserPerformanceTimeOrigin + entry.startTime);
    const duration = (0, _utils.msToSec)(metric.value);
    const activeSpan = (0, _core.getActiveSpan)();
    const rootSpan = activeSpan ? (0, _core.getRootSpan)(activeSpan) : undefined; // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
    // where we cache the route per interactionId

    const cachedSpan = interactionId != null ? INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
    const spanToUse = cachedSpan || rootSpan; // Else, we try to use the active span.
    // Finally, we fall back to look at the transactionName on the scope

    const routeName = spanToUse ? (0, _core.spanToJSON)(spanToUse).description : (0, _core.getCurrentScope)().getScopeData().transactionName;
    const name = (0, _core.htmlTreeAsString)(entry.target);
    const attributes = (0, _core.dropUndefinedKeys)({
      [_core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.http.browser.inp',
      [_core.SEMANTIC_ATTRIBUTE_SENTRY_OP]: `ui.interaction.${interactionType}`,
      [_core.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: entry.duration
    });
    const span = (0, _utils.startStandaloneWebVitalSpan)({
      name,
      transaction: routeName,
      attributes,
      startTime
    });

    if (span) {
      span.addEvent('inp', {
        [_core.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: 'millisecond',
        [_core.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: metric.value
      });
      span.end(startTime + duration);
    }
  });
}
/**
 * Register a listener to cache route information for INP interactions.
 * TODO(v9): `latestRoute` no longer needs to be passed in and will be removed in v9.
 */


function registerInpInteractionListener(_latestRoute) {
  const handleEntries = ({
    entries
  }) => {
    const activeSpan = (0, _core.getActiveSpan)();
    const activeRootSpan = activeSpan && (0, _core.getRootSpan)(activeSpan);
    entries.forEach(entry => {
      if (!(0, _instrument.isPerformanceEventTiming)(entry) || !activeRootSpan) {
        return;
      }

      const interactionId = entry.interactionId;

      if (interactionId == null) {
        return;
      } // If the interaction was already recorded before, nothing more to do


      if (INTERACTIONS_SPAN_MAP.has(interactionId)) {
        return;
      } // We keep max. 10 interactions in the list, then remove the oldest one & clean up


      if (LAST_INTERACTIONS.length > 10) {
        const last = LAST_INTERACTIONS.shift();
        INTERACTIONS_SPAN_MAP.delete(last);
      } // We add the interaction to the list of recorded interactions
      // and store the span for this interaction


      LAST_INTERACTIONS.push(interactionId);
      INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
    });
  };

  (0, _instrument.addPerformanceInstrumentationHandler)('event', handleEntries);
  (0, _instrument.addPerformanceInstrumentationHandler)('first-input', handleEntries);
}